<template>
  <div class="form-row">
    <div class="form-group col-md-2">
      <input
        type="text"
        class="form-control"
        id="inputFirstname"
        placeholder="First Name"
        v-model="firstName"
      />
    </div>
    <div class="form-group col-md-2">
      <input
        type="text"
        class="form-control"
        id="inputLastname"
        placeholder="Last Name"
        v-model="lastName"
      />
    </div>
    <div class="form-group col-md-2">
      <input
        type="email"
        class="form-control"
        id="inputemail"
        placeholder="Email Address"
        v-model="email"
      />
    </div>
    <div class="form-group col-md-2">
      <input
        type="tel"
        class="form-control"
        id="inputNumber"
        placeholder="Phone Number"
        v-model="phone"
      />
    </div>
    <div class="form-group col-md-2">
      <input type="text" class="form-control" id="inputID" placeholder="Staff ID" v-model="staffId" />
    </div>
    <span class="text-danger">x</span>
  </div>
</template>
<script>
export default {
  name: "FormInput",
  data() {
    return {
      email: "",
      lastName: "",
      firstName: "",
      phone: "",
      staffId: ""
    };
  }
};
</script>

<style lang="scss" scoped>
.form-row {
  height: 75px;
}
.form-group {
  margin-right: 25px;

  input {
    width: 140px;
  }
}
::placeholder {
  color: #777777;
  opacity: 0.5;
  font-size: 0.729vw;
}
span {
  width: 2px;
  padding: 5px 0px 0px 2px;
}
</style>

